import { useMemo } from "react";
import { format } from "date-fns";
import useGetSales, { EModules } from "api/useGetSales";
import StatisticCard, { IStatisticCardProps } from "components/StatisticCard";
import apiDateFormat from "constants/apiDateFormat";
import { currentMonth, today } from "constants/commonDateRanges";
import styles from "pages/Home/styles.module.scss";
import { useAppSelector } from "hooks/store";
import { selectUserData } from "store/auth/authSlice";
import { FaEye } from "react-icons/fa";
import { FaArrowTrendUp } from "react-icons/fa6";
import { FaCarRear } from "react-icons/fa6";
import { BiTask } from "react-icons/bi";
import { BsFillBarChartFill } from "react-icons/bs";
import { IoMdSpeedometer } from "react-icons/io";


const ResultsSummary = () => {

  const userAuth = useAppSelector(selectUserData);

  // const module = userAuth.inventory.value === 'new' ? EModules.ResultsSummaryV2 : EModules.ResultsSummary;

  const resultSummary = useGetSales<EModules.ResultsSummaryV2>({
    module: EModules.ResultsSummaryV2,
    params: {
      dealership_uid: userAuth.dealerV2.uid,
      date_from: format(currentMonth.startDate, apiDateFormat),
      date_to: format(currentMonth.endDate, apiDateFormat),
      inventory: userAuth.inventory.value,
    },
  });

  const formattedResultsSummary: IStatisticCardProps[] = useMemo(() => {
    
    const {
      sales_front_line_ready_ratio,
      front_line_ready,
      sales_pace,
      vdp_pace,
      total_vdp,
      average_vdp_per_vehicle,
    } = resultSummary.data || {};

    const getArrowDirection = (growth: number | null) =>
      typeof growth === "number" ? (growth > 0 ? "up" : "down") : null;

    return [
      {
        leftSection: {
          // arrowDirection: getArrowDirection(0),
          // growth: 0,
          showGrowth: false,
          label: "Total VDPs",
          total: total_vdp || 0,
          description: "Last Month",
          icon: FaEye,
        },
        rightSection: {
          // arrowDirection: getArrowDirection(0),
          // growth: 0,
          showGrowth: false,
          label: "VDP Pace",
          total: vdp_pace || 0,
          description: "Month to Date",
          icon: FaArrowTrendUp,
        },
      },
      {
        leftSection: {
          // arrowDirection: getArrowDirection(0),
          growth: 0,
          showGrowth: false,
          label: "Avg VDPs / Vehicle",
          total: average_vdp_per_vehicle || 0,
          description: "Month to Date",
          icon: FaCarRear,
        },
        rightSection: {
          // arrowDirection: getArrowDirection(
          //   typeof front_line_ready?.growth !== "undefined"
          //     ? front_line_ready.growth
          //     : 0
          // ),
          // growth: front_line_ready?.growth || 0,
          label: "Front Line Ready",
          total: front_line_ready || 0,
          showGrowth: true,
          description: "Month to Date",
          icon: BiTask,
        },
      },
      {
        leftSection: {
          // arrowDirection: getArrowDirection(
          //   typeof sales_front_line_ready_ratio?.growth !== "undefined"
          //     ? sales_front_line_ready_ratio.growth
          //     : 0
          // ),
          // growth: sales_front_line_ready_ratio?.growth || 0,
          label: "Sales to FLR Ratio",
          total: sales_front_line_ready_ratio || 0,
          showGrowth: true,
          description: "Month to Date",
          icon: BsFillBarChartFill,
        },
        rightSection: {
          // arrowDirection: getArrowDirection(
          //   typeof sales_pace?.growth !== "undefined" ? sales_pace.growth : 0
          // ),
          // growth: sales_pace?.growth || 0,
          label: "Sales Pace",
          total: sales_pace || 0,
          showGrowth: true,
          description: "Month to Date",
          icon: IoMdSpeedometer,
        },
        // rightSection: {
        //   arrowDirection:
        //     typeof average_days_to_sell?.growth === "number"
        //       ? average_days_to_sell.growth > 0
        //         ? "down"
        //         : "up"
        //       : null,
        //   growth: average_days_to_sell?.growth || 0,
        //   label: "Average Days to Sell",
        //   total: average_days_to_sell?.total || 0,
        //   showGrowth: true,
        //   description: "Month to Date"
        // },
      },
    ] as IStatisticCardProps[];
  }, [resultSummary.data]);

  return (
    <div className={styles.metricsContainer}>
      {formattedResultsSummary.map(({ leftSection, rightSection }, index) => (
        <StatisticCard
          key={index}
          leftSection={leftSection}
          rightSection={rightSection}
        />
      ))}
    </div>
  );
};

export default ResultsSummary;
